export const documentWorkspacePermission = (subdomain: string): string =>
  subdomain === "admin"
    ? "frontend_view_admin_documents"
    : "frontend_view_document";
